import { render, staticRenderFns } from "./FAQComponent.vue?vue&type=template&id=192d2648&"
import script from "./FAQComponent.vue?vue&type=script&lang=js&"
export * from "./FAQComponent.vue?vue&type=script&lang=js&"
import style0 from "./FAQComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports